import type React from 'react';

import { Button } from '@xing-com/button';
import { IconEdit } from '@xing-com/icons';

import {
  ARTICLES_ARTICLE_EDIT_LINK,
  CONTENT_ARTICLE_EDIT_LINK,
} from '../../../../constants/urls';
import type { ArticleCardView } from '../../../../types/types';

type Props = {
  article: ArticleCardView;
  ccpId: string;
};

export const EditArticleButton: React.FC<Props> = ({ article, ccpId }) => {
  const editUrl =
    article.typename === 'ContentArticle'
      ? CONTENT_ARTICLE_EDIT_LINK(ccpId.split('.')[0], article.id.split('.')[0])
      : ARTICLES_ARTICLE_EDIT_LINK(article.id);

  return (
    <Button icon={IconEdit} size="small" variant="tertiary" href={editUrl} />
  );
};
